// extracted by css-extract-rspack-plugin
export default {"toggleButton":"product-detail-fragment__ToggleButton_toggleButton__GvUSm","isSelected":"product-detail-fragment__ToggleButton_isSelected__L3vZL"};